import React, { useState, useEffect, useCallback, useMemo } from 'react';
import './Carousel.css';
import activitycarousel1 from '../images/activitycarousel1.webp';
import activitycarousel2 from '../images/activitycarousel2.webp';
import activitycarousel3 from '../images/activitycarousel3.webp';
import activitycarousel4 from '../images/activitycarousel4.webp';
import activitycarousel5 from '../images/activitycarousel5.webp';
import activitycarousel6 from '../images/activitycarousel6.webp';

const CarouselActivity = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Wrap slides array in useMemo to prevent unnecessary recreations
  const slides = useMemo(() => [
    {
      image: activitycarousel1,
      cta: 'IDC-2 Kiradpura'
    },
    {
      image: activitycarousel2,
      cta: 'Study Centre'
    },
    {
      image: activitycarousel3,
      cta: 'View Publications'
    },
    {
      image: activitycarousel4,
      cta: 'ITI Certification Distribution Program on 14-Feb-2023'
    },
    {
      image: activitycarousel5,
      cta: 'Dastarkhawan'
    },
    {
      image: activitycarousel6,
      cta: 'Free Artificial Legs Distribution Event'
    }
  ], []); // Empty dependency array means this only gets created once

  // Preload next and previous images for smoother transitions
  useEffect(() => {
    const preloadIndices = [
      currentSlide,
      (currentSlide + 1) % slides.length,
      (currentSlide - 1 + slides.length) % slides.length
    ];

    preloadIndices.forEach(index => {
      const img = new Image();
      img.src = slides[index].image;
    });
  }, [currentSlide, slides]);

  // Smooth transition to next slide
  const goToNext = useCallback(() => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  }, [isTransitioning, slides.length]);

  // Smooth transition to previous slide
  const goToPrev = useCallback(() => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  }, [isTransitioning, slides.length]);

  // Direct slide navigation
  const goToSlide = useCallback((index) => {
    if (isTransitioning || index === currentSlide) return;
    setIsTransitioning(true);
    setCurrentSlide(index);
  }, [isTransitioning, currentSlide]);

  // Auto-advance with transition completion handling
  useEffect(() => {
    const interval = setInterval(goToNext, 5000);
    return () => clearInterval(interval);
  }, [goToNext]);

  // Reset transitioning state after animation completes
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTransitioning(false);
    }, 600); // Match this with CSS transition duration

    return () => clearTimeout(timer);
  }, [currentSlide]);

  return (
    <div className="carousel-container">
      <div 
        className={`carousel-slides ${isTransitioning ? 'transitioning' : ''}`}
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {slides.map((slide, index) => (
          <div key={index} className="slide">
            <div className="image-container">
              <div className="image-overlay"></div>
              <img 
                src={slide.image} 
                alt={`Banner ${index + 1}`} 
                className="slide-image"
                loading={index === 0 ? "eager" : "lazy"} // First image eager, others lazy
                onError={(e) => {
                  e.target.src = '/placeholder-banner.webp';
                }}
              />
            </div>
            <div className="slide-content">
              <button className="slide-cta">{slide.cta}</button>
            </div>
          </div>
        ))}
      </div>

      <button 
        className="carousel-control prev" 
        onClick={goToPrev} 
        aria-label="Previous slide"
        disabled={isTransitioning}
      >
        &#10094;
      </button>
      <button 
        className="carousel-control next" 
        onClick={goToNext} 
        aria-label="Next slide"
        disabled={isTransitioning}
      >
        &#10095;
      </button>

      <div className="carousel-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
            disabled={isTransitioning}
          />
        ))}
      </div>
    </div>
  );
};

export default CarouselActivity;





















// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import './Carousel.css';
// import activitycarousel1 from '../images/activitycarousel1.webp';
// import activitycarousel2 from '../images/activitycarousel2.webp';
// import activitycarousel3 from '../images/activitycarousel3.webp';
// import activitycarousel4 from '../images/activitycarousel4.webp';
// import activitycarousel5 from '../images/activitycarousel5.webp';
// import activitycarousel6 from '../images/activitycarousel6.webp';

// const CarouselActivity = () => {
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [isTransitioning, setIsTransitioning] = useState(false);
//   const [loadedImages, setLoadedImages] = useState(new Set());
//   const [preloadedNext, setPreloadedNext] = useState(new Set());

//   // Wrap slides array in useMemo to prevent unnecessary recreations
//   const slides = useMemo(() => [
//     {
//       image: activitycarousel1,
//       cta: 'IDC-2 Kiradpura'
//     },
//     {
//       image: activitycarousel2,
//       cta: 'Study Centre'
//     },
//     {
//       image: activitycarousel3,
//       cta: 'View Publications'
//     },
//     {
//       image: activitycarousel4,
//       cta: 'ITI Certification Distribution Program on 14-Feb-2023'
//     },
//     {
//       image: activitycarousel5,
//       cta: 'Dastarkhawan'
//     },
//     {
//       image: activitycarousel6,
//       cta: 'Free Artificial Legs Distribution Event'
//     }
//   ], []); // Empty dependency array means this only gets created once

//   // Handle image load
//   const handleImageLoad = useCallback((index) => {
//     setLoadedImages(prev => new Set(prev).add(index));
//   }, []);

//   // Preload next and previous images for smoother transitions
//   useEffect(() => {
//     const preloadIndices = [
//       currentSlide,
//       (currentSlide + 1) % slides.length,
//       (currentSlide - 1 + slides.length) % slides.length
//     ];

//     preloadIndices.forEach(index => {
//       if (!preloadedNext.has(index)) {
//         const img = new Image();
//         img.src = slides[index].image;
//         img.onload = () => {
//           setPreloadedNext(prev => new Set(prev).add(index));
//         };
//       }
//     });
//   }, [currentSlide, slides, preloadedNext]);

//   // Smooth transition to next slide
//   const goToNext = useCallback(() => {
//     if (isTransitioning) return;
//     setIsTransitioning(true);
//     setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
//   }, [isTransitioning, slides.length]);

//   // Smooth transition to previous slide
//   const goToPrev = useCallback(() => {
//     if (isTransitioning) return;
//     setIsTransitioning(true);
//     setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
//   }, [isTransitioning, slides.length]);

//   // Direct slide navigation
//   const goToSlide = useCallback((index) => {
//     if (isTransitioning || index === currentSlide) return;
//     setIsTransitioning(true);
//     setCurrentSlide(index);
//   }, [isTransitioning, currentSlide]);

//   // Auto-advance with transition completion handling
//   useEffect(() => {
//     const interval = setInterval(goToNext, 5000);
//     return () => clearInterval(interval);
//   }, [goToNext]);

//   // Reset transitioning state after animation completes
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setIsTransitioning(false);
//     }, 600); // Match this with CSS transition duration

//     return () => clearTimeout(timer);
//   }, [currentSlide]);

//   // Check if image is loaded
//   const isImageLoaded = (index) => {
//     return loadedImages.has(index);
//   };

//   return (
//     <div className="carousel-container">
//       <div 
//         className={`carousel-slides ${isTransitioning ? 'transitioning' : ''}`}
//         style={{ transform: `translateX(-${currentSlide * 100}%)` }}
//       >
//         {slides.map((slide, index) => (
//           <div key={index} className="slide">
//             <div className="image-container">
//               <div className="image-overlay"></div>
//               {!isImageLoaded(index) && (
//                 <div className="carousel-placeholder">
//                   <div className="carousel-loading-spinner"></div>
//                   <span>Loading...</span>
//                 </div>
//               )}
//               <img 
//                 src={slide.image} 
//                 alt={`Banner ${index + 1}`} 
//                 className={`slide-image ${isImageLoaded(index) ? 'loaded' : 'loading'}`}
//                 loading={index === 0 ? "eager" : "lazy"} // First image eager, others lazy
//                 onLoad={() => handleImageLoad(index)}
//                 onError={(e) => {
//                   e.target.src = '/placeholder-banner.webp';
//                   handleImageLoad(index); // Mark as loaded even if error
//                 }}
//               />
//             </div>
//             <div className="slide-content">
//               <button className="slide-cta">{slide.cta}</button>
//             </div>
//           </div>
//         ))}
//       </div>

//       <button 
//         className="carousel-control prev" 
//         onClick={goToPrev} 
//         aria-label="Previous slide"
//         disabled={isTransitioning}
//       >
//         &#10094;
//       </button>
//       <button 
//         className="carousel-control next" 
//         onClick={goToNext} 
//         aria-label="Next slide"
//         disabled={isTransitioning}
//       >
//         &#10095;
//       </button>

//       <div className="carousel-indicators">
//         {slides.map((_, index) => (
//           <button
//             key={index}
//             className={`indicator ${index === currentSlide ? 'active' : ''}`}
//             onClick={() => goToSlide(index)}
//             aria-label={`Go to slide ${index + 1}`}
//             disabled={isTransitioning}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default CarouselActivity;